import React from 'react'
import { Card, Select, Typography } from 'antd'
import { MedicineBoxOutlined } from '@ant-design/icons'

const { Text } = Typography

const DoctorSelection = ({
  selectedMedicalProfessional,
  setSelectedMedicalProfessional,
  setPatient,
  setService,
  medicalProfessionals,
  token
}) => {
  return (
    <Card
      title={
        <>
          <MedicineBoxOutlined style={{ color: token.colorPrimary }} /> Doctor
        </>
      }
      bordered={false}
      size='small'
      style={{ boxShadow: '0 1px 2px rgba(0,0,0,0.05)', height: '100%' }}
      headStyle={{ padding: '6px 10px', fontSize: '13px' }}
      bodyStyle={{ padding: '8px 10px' }}
    >
      <div style={{ marginBottom: '8px' }}>
        <Text
          strong
          style={{
            display: 'block',
            marginBottom: '8px',
            color: token.colorTextSecondary,
            fontSize: '12px'
          }}
        >
          Select Medical Professional:
        </Text>
        <Select
          showSearch
          optionFilterProp='search'
          placeholder='- Select Medical Professional -'
          style={{ width: '100%' }}
          size='middle'
          value={selectedMedicalProfessional?._id || undefined}
          onChange={(value) => {
            const selectedDoctor = medicalProfessionals.find((medprof) => medprof._id === value)
            setSelectedMedicalProfessional(selectedDoctor)
            // Reset patient and service when doctor changes
            setPatient(null)
            setService(null)
          }}
          options={medicalProfessionals.map((medprof) => ({
            search: `${medprof.firstName} ${medprof.lastName}`,
            label: (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span>
                  {medprof.extraData.profession === 'doctor' ? 'Dr. ' : ''}
                  {medprof.firstName.charAt(0).toUpperCase()}. {medprof.lastName}
                </span>
                {medprof.onDuty && (
                  <span
                    style={{
                      color: token.colorSuccess,
                      fontSize: '10px',
                      fontWeight: 'bold'
                    }}
                  >
                    ON DUTY
                  </span>
                )}
              </div>
            ),
            value: medprof._id
          }))}
        />
      </div>
    </Card>
  )
}

export default DoctorSelection
